/** @file wrapDegrees: wraps an angle in degrees into [0, 360). */

/** `deg` wrapped into [0, 360); never returns 360 or -0. */
export function wrapDegrees(deg: number): number {
  const r = deg % 360;
  const w = r < 0 ? r + 360 : r;
  return w >= 360 ? 0 : w + 0;
}
